import { ClientDetails } from "../../../../../../Wrap/Models/Models/Processes/Quote/ClientDetails";

export class ClientNameHelper {
    static clientNameDisplay(firstClientDetails: ClientDetails, secondClientDetails: ClientDetails) {
        let name = "";
        if (secondClientDetails) {
            if (
                firstClientDetails?.LastName !== undefined &&
                firstClientDetails?.LastName == secondClientDetails?.LastName
            ) {
                name = `${firstClientDetails?.FirstName} & ${secondClientDetails?.FirstName} ${secondClientDetails?.LastName}`;
            } else if (firstClientDetails?.LastName === undefined || secondClientDetails?.LastName === undefined) {
                name = `${firstClientDetails?.FirstName} & ${secondClientDetails?.FirstName}`;
            } else {
                name = `${firstClientDetails?.FirstName} ${firstClientDetails?.LastName} & ${secondClientDetails?.FirstName} ${secondClientDetails?.LastName}`;
            }
        } else {
            name = `${firstClientDetails?.FirstName ?? ""} ${firstClientDetails?.LastName ?? ""}`;
        }
        return name;
    }
}
